import { RemoteOptionsArray } from '@asgard/common-dto';
import { ListItemStringValue } from 'interfaces/ui/ui-list-item';

export const DEFAULT_CURRENCY_VALUE = { label: '€', value: '€' };

export const REMOTE_OPTIONS: ListItemStringValue[] = RemoteOptionsArray.map(
  (opt) => ({
    label: opt,
    value: opt
  })
);
